import React from 'react';

export default class ShGoogleMap extends React.Component {
  render() {
    const { showAddress, showMap, latitude, longitude } = this.props.listing;

    return (
      <sh-google-map showAddress={showAddress} showMap={showMap} latitude={latitude} longitude={longitude}></sh-google-map>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/listing-detail/sh-wrappers/sh-google-map.js